<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent"><br/><br/></p>
<p class="also"><a id="page_ii"></a>ALSO BY SCOTTY MCLENNAN</p>
<p class="noindent"><em>Finding Your Religion: When the Faith You Grew Up with Has Lost Its Meaning</em></p>
<p class="noindent"><em>Church on Sunday, Work on Monday: The Challenge of Fusing</em></p>
<p class="noindent"><em>Christian Values with Business Life</em>, coauthored with Laura Nash</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780230240582_02_alsoby.vue?346b5325